const getters = {
  loginForm: state => state.app.loginForm,
  payConfirm: state => state.app.payConfirm,
  payOrderId: state => state.app.payOrderId,
  hotGameList: state => state.user.hotGameList,
  lastRole: state => state.user.lastRole,
  accountId: state => state.user.accountId,
  nickname: state => state.user.nickname,
  accessToken: state => state.user.accessToken,
  gameIds: state => state.user.gameIds,
  validAccountForm: state => state.user.validAccountForm,
  }
  export default getters
  


// WEBPACK FOOTER //
// ./src/store/getters.js